export default {"src":"/_next/static/image/public/images/flags/flag_86.0aefe8ac8ad4ede41f778f8f5c0158ab.svg","height":16,"width":24};